export const IS_LOGGED = 'P2B_PORTAL_IS_LOGGED';
export const AUTH_TOKEN = 'P2B_PORTAL_AUTH_TOKEN';
export const WHITELABEL = 'P2B_PORTAL_WHITELABEL';
